import { useCallback, useEffect, useState } from 'react';

import { ModalContent, ModalData, useOptionalContent } from '../services/content';

export const MODAL_STORAGE_KEY = '@shared-header-footer:modal-revision';

export interface OpenedModal {
  data: ModalData;
  isOpen: true;
  close: () => void;
}

export interface ClosedModal {
  isOpen: false;
}

export const useModalState = (): OpenedModal | ClosedModal => {
  const { data: modal, isFetching } = useOptionalContent(ModalContent);

  const [dismissedRevision, setDismissedRevision] = useState<string | null>(null);

  const currentModalRevision = modal ? `${modal.id}:${modal.publishedVersion}` : null;

  useEffect(() => {
    const initialDismissedRevision = localStorage.getItem(MODAL_STORAGE_KEY);

    if (initialDismissedRevision) {
      setDismissedRevision(initialDismissedRevision);
    }
  }, []);

  const close = useCallback(() => {
    if (!currentModalRevision) {
      return;
    }

    localStorage.setItem(MODAL_STORAGE_KEY, currentModalRevision);
    setDismissedRevision(currentModalRevision);
  }, [currentModalRevision]);

  if (!modal || isFetching || currentModalRevision === dismissedRevision) {
    return { isOpen: false };
  }

  return {
    isOpen: true,
    data: modal,
    close,
  };
};
